/// <reference path="../../app.definition.ts" />
export class ViewPortData {
    /**
    * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
    */
    loadedPages: Object;
    totalItems: number;
    totalPages: number;
    /** @type {number} Total number of items. */
    numItems: number;

    /** @const {number} Number of items to fetch per request. */
    PAGE_SIZE: number;
    fetchPage: Function;
    gridItemSize: number;
    itemPadding: number;

    constructor(loadedPages = {}, numItems = 0, pageSize = 10, totalItems = 0, gridItemSize = 1) {
        this.loadedPages = loadedPages;
        this.numItems = numItems;
        this.PAGE_SIZE = pageSize;
        this.totalItems = Math.ceil(totalItems / gridItemSize);
        this.itemPadding = totalItems % (pageSize * gridItemSize);
        this.gridItemSize = gridItemSize;
        this.totalPages = Math.ceil(this.totalItems / pageSize);
    }

    refreshViewPortData(loadedPages = {}, numItems = 0, totalItems = 0) {
        this.loadedPages = loadedPages;
        this.numItems = numItems;
        this.totalItems = Math.ceil(totalItems / this.gridItemSize);
        this.itemPadding = totalItems % (this.PAGE_SIZE * this.gridItemSize);
        this.totalPages = Math.ceil(this.totalItems / this.PAGE_SIZE);
    }

    getLength() {
        if (this.numItems > (this.totalItems * this.gridItemSize)) {
            this.numItems = this.totalItems * this.gridItemSize;
        }
        return Math.ceil(this.numItems / this.gridItemSize);
    }

    getPageStartEndIndexes(pageNumber, pageOffset = 0, itemPadding = 0, isAdjusted = false) {
        (pageOffset != 0) && (pageNumber -= pageOffset);
        //if current collection adjusted with the other collections i.e. two collection in same page are different
        var size = this.PAGE_SIZE * this.gridItemSize;
        var startIndex = (pageNumber * size) - (!isAdjusted ? itemPadding : 0);
        var endIndex = startIndex + size - (isAdjusted ? itemPadding : 0);
        if ((this.totalPages - pageOffset - 1) == pageNumber) {
            var modulo = 0;
            if (this.gridItemSize == 1) {
                modulo = (this.totalItems % size);
                endIndex = startIndex + (modulo == 0 ? size : modulo);
            } else {
                modulo = (this.itemPadding == 0 ? this.gridItemSize * this.PAGE_SIZE : this.itemPadding);
                endIndex = startIndex + modulo;
            }
        }
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            pageSize: size
        };
    }

    getItemAtIndex(index) {
        var pageNumber = Math.floor(index / this.PAGE_SIZE);
        var page = this.loadedPages[pageNumber];
        if (page) {
            return page[index % this.PAGE_SIZE];
        } else if (page !== null) {
            this.fetchPage(pageNumber);
        }
    };
}

export class InfiniteList {
    numLoaded_: number;
    toLoad_: number;
    items: any[];
    page: number;
    hasMoreItems: boolean;
    perPage: number;
    fetchMoreItems_: Function;

    constructor(pageSize = 10) {
        this.numLoaded_ = -1;
        this.toLoad_ = 0;
        this.items = [];
        this.page = -1;
        this.hasMoreItems = true;
        this.perPage = pageSize;
    }

    getItemAtIndex(index) {
        if (index > this.numLoaded_) {
            this.fetchMoreItems_(index);
            return null;
        }
        return this.items[index];
    }

    getLength() {
        return this.numLoaded_;
    }

    getPageStartEndIndexes(pageNumber, pageOffset = 0, itemPadding = 0, isAdjusted = false) {
        (pageOffset != 0) && (pageNumber -= pageOffset);
        //if current collection adjusted with the other collections i.e. two collection in same page are different
        var size = this.perPage;
        var startIndex = (pageNumber * size) - (!isAdjusted ? itemPadding : 0);
        var endIndex = startIndex + size - (isAdjusted ? itemPadding : 0);
        return {
            startIndex: startIndex,
            endIndex: endIndex,
            pageSize: size
        };
    }
}
